var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1758609473262,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 13563,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.914667 0C405.418667 0 314.538667 37.717333 239.872 112.64 165.290667 187.733333 127.914667 278.186667 127.914667 384c0 98.133333 32.426667 182.954667 97.109333 254.634667a372.821333 372.821333 0 0 0 241.749333 123.989333V1024h98.474667V761.685333c95.061333-13.226667 174.08-55.125333 236.8-126.293333 62.634667-70.741333 94.037333-154.709333 94.037333-251.306667 0-105.898667-37.290667-196.522667-111.957333-271.36C709.461333 37.290667 618.410667 0 511.914667 0z m194.474666 574.293333c-53.76 52.224-118.613333 78.336-194.645333 78.336-75.946667 0-140.629333-26.112-193.365333-78.336-52.565333-52.309333-79.018667-116.053333-79.018667-191.402666 0-76.202667 26.282667-140.544 79.018667-193.194667 52.736-52.650667 117.333333-78.933333 193.365333-78.933333 76.544 0 141.482667 26.282667 194.816 78.677333 53.504 52.48 80.213333 117.248 80.213333 193.877333 0 75.093333-26.709333 139.093333-80.384 190.976z",
    fill: "#6B7280",
    "p-id": 13564
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.927b3f16.svg";
export { ForwardRef as ReactComponent };